import axios from "@/plugins/axios";

export function getBlogList(pageNum, pageSize) {
  return axios({
    url: `/Article/GetPageList?`,
    method: "GET",
    params: {
      pageIndex: pageNum,
      pageSize,
    },
  });
}
